export default {
  alias: 'Alias',
  description: 'Description',
  glNumber: 'GL number',
  glType: 'GL Type',
  regulatoryType: 'Regulatory Type',
  withClosed: 'With closed',
  accountName: 'Name',
  branch: 'Branch',
  number: 'Number',
  currency: 'Currency',
  liquidityBucket: 'Liquidity bucket',
  productTemplateCode: 'Product template',
  accountNumbering: 'Account numbering',
  type: 'Type',
  productId: 'Product',
  addPnl: "Add Tenant's Account",
  editPnl: 'Edit Name, Alias and Description',
  accountDetails: 'Account details',
  accountSummary: 'Account Summary',
  balance: 'Balance',
  amount: 'Amount',
  status: 'Status',
  systemInfo: 'System information',
  nameAliasAndDescription: 'Name, Alias and Description',
  balancesAndCounters: 'Balances and counters',
  productTemplateName: 'Product template name',
  detailsProductTemplateCode: 'Product template code',
  productTemplateCategory: 'Product template category',
  currentDay: 'Current day',
  accountNumber: 'Account number',
  tabs: {
    details: 'Details',
    bankDaySummary: 'Bank day summary',
    transactions: 'Transactions',
  },
  bankDaySummary: {
    toDate: 'To date',
    fromDate: 'From date',
    bankingDay: 'Banking day',
    totalOperations: 'Total operations number',
    totalAmount: 'Total amount',
    warning: 'The bank day summary is available only for the last 90 days.',
  },
  productTemplateFallback:
    'Product template for this account is missing. No current balance/counters/limits information is available. Account can not be used to run transactions.',
};
